import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SaveIcon from '@material-ui/icons/CheckCircle';
import FormHelperText from '@material-ui/core/FormHelperText';
import CircularProgress from '@material-ui/core/CircularProgress';
import { errorColor } from 'theme/Theme';
import { Row } from 'components/UI/Row';
import { saveExternalSerialNumber, getSerialNumbersLoaders, getSerialNumbersApiErrors } from './serialNumbers';

const SerialNumberExternal: FC<{ disabled: boolean; externalValue?: string; serialValue: string }> = ({
  disabled,
  externalValue,
  serialValue
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isSavingItems } = useSelector(getSerialNumbersLoaders);
  const { savingErrorItems } = useSelector(getSerialNumbersApiErrors);
  const [extValue, setExtValue] = useState<string>(externalValue || '');
  return (
    <>
      <Row alignItems="center">
        <TextField
          fullWidth
          label={t('products.third party serial number')}
          margin="dense"
          variant="outlined"
          disabled={disabled}
          onChange={e => setExtValue(e.target.value)}
          value={extValue}
        />

        <IconButton
          aria-label="delete"
          disableRipple
          disableFocusRipple
          disabled={disabled}
          color="primary"
          onClick={() =>
            dispatch(
              saveExternalSerialNumber({
                externalValue: extValue,
                serialNumber: serialValue
              })
            )
          }
        >
          <SaveIcon />
          {isSavingItems && isSavingItems[serialValue] && (
            <CircularProgress
              color="primary"
              size={34}
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: -17,
                marginLeft: -17
              }}
            />
          )}
        </IconButton>
      </Row>
      <FormHelperText style={{ color: errorColor, position: 'absolute', bottom: '3px' }}>
        {savingErrorItems && savingErrorItems[serialValue]}
      </FormHelperText>
    </>
  );
};

export { SerialNumberExternal };
